
import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';

import CitiesModule from '@/store/cities';
import DirectoriesModule from '@/store/directories';

@Component({
    components: {
        Layout,
        ListBlock,
    },
})
export default class CitiesPage extends Vue {
    repository = CitiesModule;

    get tabsNav() {
        return DirectoriesModule.tabsNav;
    }

    get currentTab() {
        return DirectoriesModule.allTabs.cities.id;
    }

    get filterSettings() {
        return this.repository.filter.filterSettings;
    }

    toAdd() {
        this.$router.push({ name: 'cities_create' });
    }

    async updateList() {
        await this.repository.filter.updateFilter();
        await this.repository.updatePage('1');
    }

    async resetFilters() {
        await this.repository.clearSort();
        await this.repository.filter.resetFilter();
        await this.repository.updatePage('1');
    }
}
